import { createIcon } from "@chakra-ui/icons";

// Created from mIconVector.svg (part of QGIS icons)

export const VectorIcon = createIcon({
  displayName: "VECTOR",
  viewBox: "0 0 16 17",
  path: (
    <g id="vector">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 7.09999C0.5 19.1 6.5 9.09999 9.5 9.09999C11.5 9.09999 15.5 13.1 15.5 8.09999C15.5 0.099987 11.102 4.90999 8.5 4.09999C6.558 3.49599 0.5 0.099987 0.5 7.09999Z"
        fill="url(#paint0_linear_6949_7312)"
        stroke="#2B3B4D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6949_7312"
          x1="4.74"
          y1="5.44199"
          x2="6.5"
          y2="11.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEEEEE" />
          <stop offset="1" stopColor="#AEC7E2" />
        </linearGradient>
      </defs>
    </g>
  ),
});
